import React from 'react'
import { Container } from './ProspectsCards.styles'
import { GridContainer, GridItem } from 'src/components/common/grids'
import ProspectsCS from './ProspectsCS/ProspectsCS'
import ProspectsUserInfo from './ProspectsUserInfo/ProspectsUserInfo'
import ProspectsNotes from './ProspectsNotes/ProspectsNotes'
import OrderInput from 'src/components/common/OrderInput/OrderInput'
import { HeaderProspectsOption } from '../constants/ProspectsHeaderTable'
import { Prospect } from 'src/redux/prospects/prospects.types'

export interface IProspectsCardsProps {
    prospect?: Prospect | null
    loading: boolean
}

const ProspectsCards = ({ prospect, loading }: IProspectsCardsProps) => {
    return (
        <Container>
            <GridContainer p-sm="0px">
                <GridItem lg-d-none className="header_table">
                    <OrderInput label={HeaderProspectsOption[0].label} />
                </GridItem>
                <GridItem md={8} lg={4}>
                    <ProspectsCS prospect={prospect} loading={loading} />
                </GridItem>
                <GridItem lg-d-none className="header_table">
                    <OrderInput label={HeaderProspectsOption[1].label} />
                </GridItem>
                <GridItem md={8} lg={4}>
                    <ProspectsUserInfo prospect={prospect} loading={loading} />
                </GridItem>
                <GridItem lg-d-none className="header_table">
                    <OrderInput label={HeaderProspectsOption[2].label} />
                </GridItem>
                <GridItem md={8} lg={4}>
                    <ProspectsNotes prospect={prospect} loading={loading} />
                </GridItem>
            </GridContainer>
        </Container>
    )
}

export default ProspectsCards